import { siteIdForPath } from '../siteConfig/branding';

/**
 * Resolve the active site id from the Redux store.
 *
 * In seamless single-build mode every frontend instance is bound to exactly one
 * backend site (RAZZLE_INTERNAL_API_PATH=.../standards|directives|nnsa). The
 * router pathname is site-relative (flattened), so it never carries the site
 * segment — but the content response stored in Redux keeps the *raw* backend
 * `@id`s (including `/standards`, `/directives`, `/nnsa`) on the content object
 * and its expanded `@components`. Those are serialized into `window.__data`, so
 * this selector returns the same answer on the server and after hydration.
 *
 * We scan a handful of slices that are reliably present on any content route and
 * return the first that resolves to a known site. Returns null if none match
 * (callers fall back to the default brand).
 */
export function siteIdFromState(state) {
  if (!state) return null;
  const data = state.content && state.content.data;
  const comp = data && data['@components'];
  const candidates = [
    data && data['@id'],
    comp && comp.breadcrumbs && comp.breadcrumbs['@id'],
    comp && comp.navigation && comp.navigation['@id'],
    comp && comp.actions && comp.actions['@id'],
    comp && comp.workflow && comp.workflow['@id'],
    state.breadcrumbs && state.breadcrumbs['@id'],
    state.navigation && state.navigation['@id'],
    state.navigation &&
      Array.isArray(state.navigation.items) &&
      state.navigation.items[0] &&
      state.navigation.items[0]['@id'],
  ];
  for (const c of candidates) {
    const id = siteIdForPath(c);
    if (id) return id;
  }
  return null;
}

export default siteIdFromState;
